export const getFileUrl = (uuid: string, token: string) => {
  return `${import.meta.env.VITE_APP_BACKEND_URI}${
    import.meta.env.VITE_APP_BACKEND_REST_PATH
  }/files/${uuid}?token=${token}`;
};
